// AUTO-GENERATED by scripts/optimize-images.js — do not edit by hand
import bloomAssistantWebp from './bloom-assistant-640.webp';
import bloomAssistantWebp2x from './bloom-assistant-1280.webp';
import bloomAssistantFallback from './bloom-assistant-1280.jpeg';
import devflowWebp from './devflow-640.webp';
import devflowWebp2x from './devflow-1280.webp';
import devflowFallback from './devflow-1280.jpeg';
import tollerWebp from './toller-640.webp';
import tollerWebp2x from './toller-1280.webp';
import tollerFallback from './toller-1280.jpeg';
import spectraWebp from './spectra-640.webp';
import spectraWebp2x from './spectra-1280.webp';
import spectraFallback from './spectra-1280.jpeg';
import expenseTrackerWebp from './expense-tracker-640.webp';
import expenseTrackerWebp2x from './expense-tracker-1280.webp';
import expenseTrackerFallback from './expense-tracker-1280.jpeg';
import patitasWebp from './patitas-640.webp';
import patitasWebp2x from './patitas-1280.webp';
import patitasFallback from './patitas-1280.jpeg';
import stagedWebp from './staged-640.webp';
import stagedWebp2x from './staged-1280.webp';
import stagedFallback from './staged-1280.jpeg';
import atriumWebp from './atrium-640.webp';
import atriumWebp2x from './atrium-1280.webp';
import atriumFallback from './atrium-1280.jpeg';
import vasantiWebp from './vasanti-640.webp';
import vasantiWebp2x from './vasanti-1280.webp';
import vasantiFallback from './vasanti-1280.jpeg';
import tiendasWebp from './tiendas-640.webp';
import tiendasWebp2x from './tiendas-1280.webp';
import tiendasFallback from './tiendas-1280.jpeg';
import patitasDesktopWebp from './patitas-desktop-640.webp';
import patitasDesktopWebp2x from './patitas-desktop-1280.webp';
import patitasDesktopFallback from './patitas-desktop-1280.jpg';
import patitasMobileWebp from './patitas-mobile-640.webp';
import patitasMobileWebp2x from './patitas-mobile-1280.webp';
import patitasMobileFallback from './patitas-mobile-1280.jpg';
import vasantiDesktopWebp from './vasanti-desktop-640.webp';
import vasantiDesktopWebp2x from './vasanti-desktop-1280.webp';
import vasantiDesktopFallback from './vasanti-desktop-1280.jpg';
import vasantiMobileWebp from './vasanti-mobile-640.webp';
import vasantiMobileWebp2x from './vasanti-mobile-1280.webp';
import vasantiMobileFallback from './vasanti-mobile-1280.jpg';
import stagedDesktopWebp from './staged-desktop-640.webp';
import stagedDesktopWebp2x from './staged-desktop-1280.webp';
import stagedDesktopFallback from './staged-desktop-1280.jpg';
import stagedMobileWebp from './staged-mobile-640.webp';
import stagedMobileWebp2x from './staged-mobile-1280.webp';
import stagedMobileFallback from './staged-mobile-1280.jpg';
import bloomAssistantMobileWebp from './bloom-assistant-mobile-640.webp';
import bloomAssistantMobileWebp2x from './bloom-assistant-mobile-1280.webp';
import bloomAssistantMobileFallback from './bloom-assistant-mobile-1280.jpg';
import devflowDesktopWebp from './devflow-desktop-640.webp';
import devflowDesktopWebp2x from './devflow-desktop-1280.webp';
import devflowDesktopFallback from './devflow-desktop-1280.jpg';
import devflowMobileWebp from './devflow-mobile-640.webp';
import devflowMobileWebp2x from './devflow-mobile-1280.webp';
import devflowMobileFallback from './devflow-mobile-1280.jpg';
import tollerDesktopWebp from './toller-desktop-640.webp';
import tollerDesktopWebp2x from './toller-desktop-1280.webp';
import tollerDesktopFallback from './toller-desktop-1280.jpg';
import tollerMobileWebp from './toller-mobile-640.webp';
import tollerMobileWebp2x from './toller-mobile-1280.webp';
import tollerMobileFallback from './toller-mobile-1280.jpg';
import spectraDesktopWebp from './spectra-desktop-640.webp';
import spectraDesktopWebp2x from './spectra-desktop-1280.webp';
import spectraDesktopFallback from './spectra-desktop-1280.jpg';
import spectraMobileWebp from './spectra-mobile-640.webp';
import spectraMobileWebp2x from './spectra-mobile-1280.webp';
import spectraMobileFallback from './spectra-mobile-1280.jpg';
import expenseTrackerMobileWebp from './expense-tracker-mobile-640.webp';
import expenseTrackerMobileWebp2x from './expense-tracker-mobile-1280.webp';
import expenseTrackerMobileFallback from './expense-tracker-mobile-1280.jpg';
import atriumDesktopWebp from './atrium-desktop-640.webp';
import atriumDesktopWebp2x from './atrium-desktop-1280.webp';
import atriumDesktopFallback from './atrium-desktop-1280.jpg';
import atriumMobileWebp from './atrium-mobile-640.webp';
import atriumMobileWebp2x from './atrium-mobile-1280.webp';
import atriumMobileFallback from './atrium-mobile-1280.jpg';
import vasantiSpineWebp from './vasanti-spine-640.webp';
import vasantiSpineWebp2x from './vasanti-spine-1280.webp';
import vasantiSpineFallback from './vasanti-spine-1280.jpg';
import patitasSpineWebp from './patitas-spine-640.webp';
import patitasSpineWebp2x from './patitas-spine-1280.webp';
import patitasSpineFallback from './patitas-spine-1280.jpg';
import atriumSpineWebp from './atrium-spine-640.webp';
import atriumSpineWebp2x from './atrium-spine-1280.webp';
import atriumSpineFallback from './atrium-spine-1280.jpg';
import stagedSpineWebp from './staged-spine-640.webp';
import stagedSpineWebp2x from './staged-spine-1280.webp';
import stagedSpineFallback from './staged-spine-1280.jpg';
import bloomAssistantSpineWebp from './bloom-assistant-spine-640.webp';
import bloomAssistantSpineWebp2x from './bloom-assistant-spine-1280.webp';
import bloomAssistantSpineFallback from './bloom-assistant-spine-1280.jpg';
import devflowSpineWebp from './devflow-spine-640.webp';
import devflowSpineWebp2x from './devflow-spine-1280.webp';
import devflowSpineFallback from './devflow-spine-1280.jpg';
import tollerSpineWebp from './toller-spine-640.webp';
import tollerSpineWebp2x from './toller-spine-1280.webp';
import tollerSpineFallback from './toller-spine-1280.jpg';
import spectraSpineWebp from './spectra-spine-640.webp';
import spectraSpineWebp2x from './spectra-spine-1280.webp';
import spectraSpineFallback from './spectra-spine-1280.jpg';
import expenseTrackerSpineWebp from './expense-tracker-spine-640.webp';
import expenseTrackerSpineWebp2x from './expense-tracker-spine-1280.webp';
import expenseTrackerSpineFallback from './expense-tracker-spine-1280.jpg';

export interface ImageSources {
  webp: string;
  webp2x: string;
  fallback: string;
  width: number;
  height: number;
}

export const IMAGE_MANIFEST = {
  bloomAssistant: { webp: bloomAssistantWebp, webp2x: bloomAssistantWebp2x, fallback: bloomAssistantFallback, width: 1280, height: 714 },
  devflow: { webp: devflowWebp, webp2x: devflowWebp2x, fallback: devflowFallback, width: 1280, height: 714 },
  toller: { webp: tollerWebp, webp2x: tollerWebp2x, fallback: tollerFallback, width: 1280, height: 714 },
  spectra: { webp: spectraWebp, webp2x: spectraWebp2x, fallback: spectraFallback, width: 1280, height: 714 },
  expenseTracker: { webp: expenseTrackerWebp, webp2x: expenseTrackerWebp2x, fallback: expenseTrackerFallback, width: 1280, height: 714 },
  patitas: { webp: patitasWebp, webp2x: patitasWebp2x, fallback: patitasFallback, width: 1280, height: 714 },
  staged: { webp: stagedWebp, webp2x: stagedWebp2x, fallback: stagedFallback, width: 1280, height: 714 },
  atrium: { webp: atriumWebp, webp2x: atriumWebp2x, fallback: atriumFallback, width: 1280, height: 714 },
  vasanti: { webp: vasantiWebp, webp2x: vasantiWebp2x, fallback: vasantiFallback, width: 1280, height: 714 },
  tiendas: { webp: tiendasWebp, webp2x: tiendasWebp2x, fallback: tiendasFallback, width: 1280, height: 800 },
  patitasDesktop: { webp: patitasDesktopWebp, webp2x: patitasDesktopWebp2x, fallback: patitasDesktopFallback, width: 1280, height: 800 },
  patitasMobile: { webp: patitasMobileWebp, webp2x: patitasMobileWebp2x, fallback: patitasMobileFallback, width: 390, height: 844 },
  vasantiDesktop: { webp: vasantiDesktopWebp, webp2x: vasantiDesktopWebp2x, fallback: vasantiDesktopFallback, width: 1280, height: 800 },
  vasantiMobile: { webp: vasantiMobileWebp, webp2x: vasantiMobileWebp2x, fallback: vasantiMobileFallback, width: 390, height: 844 },
  stagedDesktop: { webp: stagedDesktopWebp, webp2x: stagedDesktopWebp2x, fallback: stagedDesktopFallback, width: 1280, height: 800 },
  stagedMobile: { webp: stagedMobileWebp, webp2x: stagedMobileWebp2x, fallback: stagedMobileFallback, width: 390, height: 844 },
  bloomAssistantMobile: { webp: bloomAssistantMobileWebp, webp2x: bloomAssistantMobileWebp2x, fallback: bloomAssistantMobileFallback, width: 390, height: 844 },
  devflowDesktop: { webp: devflowDesktopWebp, webp2x: devflowDesktopWebp2x, fallback: devflowDesktopFallback, width: 1280, height: 800 },
  devflowMobile: { webp: devflowMobileWebp, webp2x: devflowMobileWebp2x, fallback: devflowMobileFallback, width: 390, height: 844 },
  tollerDesktop: { webp: tollerDesktopWebp, webp2x: tollerDesktopWebp2x, fallback: tollerDesktopFallback, width: 1280, height: 800 },
  tollerMobile: { webp: tollerMobileWebp, webp2x: tollerMobileWebp2x, fallback: tollerMobileFallback, width: 390, height: 844 },
  spectraDesktop: { webp: spectraDesktopWebp, webp2x: spectraDesktopWebp2x, fallback: spectraDesktopFallback, width: 1280, height: 800 },
  spectraMobile: { webp: spectraMobileWebp, webp2x: spectraMobileWebp2x, fallback: spectraMobileFallback, width: 390, height: 844 },
  expenseTrackerMobile: { webp: expenseTrackerMobileWebp, webp2x: expenseTrackerMobileWebp2x, fallback: expenseTrackerMobileFallback, width: 390, height: 844 },
  atriumDesktop: { webp: atriumDesktopWebp, webp2x: atriumDesktopWebp2x, fallback: atriumDesktopFallback, width: 1280, height: 800 },
  atriumMobile: { webp: atriumMobileWebp, webp2x: atriumMobileWebp2x, fallback: atriumMobileFallback, width: 390, height: 844 },
  vasantiSpine: { webp: vasantiSpineWebp, webp2x: vasantiSpineWebp2x, fallback: vasantiSpineFallback, width: 116, height: 413 },
  patitasSpine: { webp: patitasSpineWebp, webp2x: patitasSpineWebp2x, fallback: patitasSpineFallback, width: 116, height: 330 },
  atriumSpine: { webp: atriumSpineWebp, webp2x: atriumSpineWebp2x, fallback: atriumSpineFallback, width: 116, height: 486 },
  stagedSpine: { webp: stagedSpineWebp, webp2x: stagedSpineWebp2x, fallback: stagedSpineFallback, width: 116, height: 377 },
  bloomAssistantSpine: { webp: bloomAssistantSpineWebp, webp2x: bloomAssistantSpineWebp2x, fallback: bloomAssistantSpineFallback, width: 116, height: 347 },
  devflowSpine: { webp: devflowSpineWebp, webp2x: devflowSpineWebp2x, fallback: devflowSpineFallback, width: 116, height: 461 },
  tollerSpine: { webp: tollerSpineWebp, webp2x: tollerSpineWebp2x, fallback: tollerSpineFallback, width: 116, height: 396 },
  spectraSpine: { webp: spectraSpineWebp, webp2x: spectraSpineWebp2x, fallback: spectraSpineFallback, width: 116, height: 325 },
  expenseTrackerSpine: { webp: expenseTrackerSpineWebp, webp2x: expenseTrackerSpineWebp2x, fallback: expenseTrackerSpineFallback, width: 116, height: 299 },
} as const satisfies Record<string, ImageSources>;

// Precise union of the manifest keys, e.g. 'patitas' | 'staged' | ...
// Use this to type lookups so a renamed/missing image is a compile error.
export type ImageKey = keyof typeof IMAGE_MANIFEST;
